// @ts-nocheck
// Thought Leaders

export const LEADERS = [
  { id: "dweck", name: "Carol Dweck", work: "Growth Mindset", bg: "linear-gradient(135deg,#fbcfe8,#db2777)", i: "CD" },
  { id: "bandura", name: "Albert Bandura", work: "Self-Efficacy", bg: "linear-gradient(135deg,#fde68a,#d97706)", i: "AB" },
  { id: "goleman", name: "Daniel Goleman", work: "Emotional Intelligence", bg: "linear-gradient(135deg,#bbf7d0,#16a34a)", i: "DG" },
  { id: "piaget", name: "Jean Piaget", work: "Cognitive Development", bg: "linear-gradient(135deg,#bae6fd,#0284c7)", i: "JP" },
  { id: "bowlby", name: "John Bowlby", work: "Attachment Theory", bg: "linear-gradient(135deg,#ddd6fe,#7c3aed)", i: "JB" },
  { id: "erikson", name: "Erik Erikson", work: "Psychosocial Stages", bg: "linear-gradient(135deg,#fecaca,#dc2626)", i: "EE" },
  { id: "epstein", name: "Joyce Epstein", work: "Parent–School", bg: "linear-gradient(135deg,#fed7aa,#ea580c)", i: "JE" },
  { id: "kalam", name: "Dr. APJ Kalam", work: "Ignited Minds", bg: "linear-gradient(135deg,#c7d2fe,#4338ca)", i: "AK" },
];
